<template>
  <div
    v-bind="$attrs"
    :class="`tag_information_card relative bg-white rounded-md w-full md:max-w-[350px] mx-4 md:mx-0 overflow-hidden ${
      isReadMore && readMore ? 'h-96' : 'h-auto'
    }`"
  >
    <div class="flex justify-left items-center space-x-3 p-5">
      <OImage :src="imgUrl" width="100" height="100" class="rounded-full border border-gray-200" />
      <div class="text-20 font-semibold">{{ data.detail.title }}</div>
    </div>
    <hr />
    <div class="px-5 pt-2 text-[15px]" v-html="data.detail.description.html"></div>
    <div
      v-if="isReadMore && readMore"
      class="tag_readmore_button text-md font-semibold w-full text-center bg-white pt-1.75 h-9 absolute bottom-0 text-o-blue"
      @click="toggleReadMoreButton()"
    >
      {{ $t('main.show-more') }}
      <OIcon icon="bottom" class="inline-block" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import { OImage, OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { getImageUrl } from '~/modules/common/utils/imageUtils';

export default defineComponent({
  components: {
    OImage,
    OIcon,
  },
  inheritAttrs: false,
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const readMore = ref(!!isMobile.value);
    const imgUrl = computed(() => getImageUrl(props.data?.detail?.image, { width: 225, standard: true }) || '');
    const isReadMore = computed(() => {
      return props.data?.detail?.description?.plain.length > 350;
    });
    const toggleReadMoreButton = () => {
      readMore.value = !readMore.value;
    };

    return { imgUrl, isMobile, isReadMore, readMore, toggleReadMoreButton };
  },
});
</script>

<style lang="scss">
.tag_information_card {
  .tag_readmore_button {
    &:before {
      content: '';
      display: block;
      position: absolute;
      background: linear-gradient(0deg, rgba(255, 255, 255, 1) 2%, rgba(255, 255, 255, 0.53687412464986) 47%, rgba(255, 255, 255, 0) 100%);
      height: 100px;
      width: 100%;
      top: -100px;
    }
  }
}
</style>
